import CustomSelect from '@/components/shared/CustomSelect/CustomSelect';
import { Input } from '@/components/shared/Input/Input';
import { currencyOptions } from '@/lib/select-options';

interface CurrencyPriceInputProps {
  formattedPrice: string;
  onPriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  currency: string;
  onCurrencyChange: (value: string) => void;
  currencies?: string[];
  label?: string;
  placeholder?: string;
  dataCy?: string;
  helperText?: string;
  className?: string;
}

export default function CurrencyPriceInput({
  formattedPrice,
  onPriceChange,
  currency,
  onCurrencyChange,
  currencies = ['BRL', 'USD'],
  label,
  placeholder,
  dataCy,
  helperText,
  className,
}: CurrencyPriceInputProps) {
  const filteredOptions = currencies.length > 0
    ? currencyOptions.filter((o) => currencies.includes(o.value))
    : currencyOptions;

  return (
    <div className={`flex gap-4 items-end w-full md:max-w-[300px] ${className || ''}`}>
      <Input
        value={formattedPrice}
        onChange={onPriceChange}
        label={label}
        placeholder={placeholder}
        data-cy={dataCy}
        helperText={helperText}
      />
      <div className="w-[100px]">
        <CustomSelect
          className="w-[56px]"
          options={filteredOptions}
          placeholder=""
          onValueChange={onCurrencyChange}
          value={currency}
          data-cy={dataCy ? `${dataCy}-currency` : undefined}
        />
      </div>
    </div>
  );
}
